import { useGLTF } from '@react-three/drei';
import PropTypes from 'prop-types';

function SedeSurquillo({ status }) {
  const { nodes, materials } = useGLTF('/models/SedeSurquillo.gltf');
  const colorInactive = 'Grey';
  return (
    <group dispose={null} position={[-35, -4.8, -16]} scale={[1, 1.3, 1.3]}>
      <group position={[0.54, 8.01, 1.02]}>
        <mesh material-color={status === false ? colorInactive : null} geometry={nodes.Cubo_1.geometry} material={materials['Material.001']} />
        <mesh
          geometry={nodes.Cubo_2.geometry}
          material-color={status === false ? colorInactive : null}
        />
        <mesh
          geometry={nodes.Cubo_3.geometry}
          material={materials.Material}
          material-color={status === false ? colorInactive : null}
        />
        <mesh geometry={nodes.Cubo_4.geometry} material={materials['Material.002']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo_5.geometry} material={materials['Material.003']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo_6.geometry} material={materials['Material.004']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo_7.geometry} material={materials['Material.005']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo_8.geometry} material={materials['Material.006']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo_9.geometry} material={materials['Material.007']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo_10.geometry} material={materials['Material.008']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo_11.geometry} material={materials['Material.009']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo_12.geometry} material={materials['Material.010']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo_13.geometry} material={materials['Material.011']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo_14.geometry} material={materials['Material.012']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo_15.geometry} material={materials['Material.013']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo_16.geometry} material={materials['Material.014']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo_17.geometry} material={materials['Material.015']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo_18.geometry} material={materials['Material.016']} material-color={status === false ? colorInactive : null} />
        <mesh geometry={nodes.Cubo_19.geometry} material={materials['Material.017']} material-color={status === false ? colorInactive : null} />
      </group>
    </group>
  );
}

useGLTF.preload('/models/SedeSurquillo.gltf');

export default SedeSurquillo;

SedeSurquillo.propTypes = {
  status: PropTypes.bool,
};

SedeSurquillo.defaultProps = {
  status: true,
};
